import React, { useState } from "react";

function getBinarySearchSteps(nums, target) {
  let steps = [];
  let left = 0;
  let right = nums.length - 1;

  steps.push({
    left,
    right,
    mid: null,
    message: "Initial boundaries set."
  });

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);

    steps.push({
      left,
      right,
      mid,
      message: `Check nums[${mid}] = ${nums[mid]}`
    });

    if (nums[mid] === target) {
      steps.push({
        left,
        right,
        mid,
        message: `Found target ${target} at index ${mid}.`
      });
      break;
    } else if (nums[mid] < target) {
      steps.push({
        left,
        right,
        mid,
        message: `Target is greater, move left to mid + 1.`
      });
      left = mid + 1;
    } else {
      steps.push({
        left,
        right,
        mid,
        message: `Target is smaller, move right to mid - 1.`
      });
      right = mid - 1;
    }
  }

  if (left > right) {
    steps.push({
      left,
      right,
      mid: null,
      message: `Target ${target} not found.`
    });
  }

  return steps;
}

const BinarySearchAnimation = () => {
  const nums = [2, 4, 7, 10, 13, 18, 21];
  const target = 13;
  const steps = getBinarySearchSteps(nums, target);

  const [stepIndex, setStepIndex] = useState(0);

  const handlePrevStep = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1);
    }
  };

  const handleNextStep = () => {
    if (stepIndex < steps.length - 1) {
      setStepIndex(stepIndex + 1);
    }
  };

  const currentStep = steps[stepIndex];
  const { left, right, mid, message } = currentStep;

  return (
    <div className="p-4 bg-gray-100 dark:bg-gray-900">
      <h4 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
        Binary Search Animation Sample
      </h4>
      <div className="flex space-x-4 mb-6">
        {nums.map((num, index) => {
          let bgColor = "bg-gray-200";

          if (index === left) bgColor = "bg-yellow-600";
          if (index === right) bgColor = "bg-pink-600";
          if (index === mid) bgColor = "bg-green-600"; 

          return (
            <div
              key={index}
              className={`w-12 h-12 flex items-center justify-center ${bgColor} rounded shadow`}
            >
              {num}
            </div>
          );
        })}
      </div>

      <div className="mb-4 space-x-2">
        <button
          onClick={handlePrevStep}
          disabled={stepIndex === 0}
          className={`px-4 py-2 rounded text-white ${
            stepIndex > 0 ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400"
          }`}
        >
          Previous Step
        </button>
        <button
          onClick={handleNextStep}
          disabled={stepIndex === steps.length - 1}
          className={`px-4 py-2 rounded text-white ${
            stepIndex < steps.length - 1
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-gray-400"
          }`}
        >
          Next Step
        </button>
      </div>

      <div className="bg-white dark:bg-gray-800 p-4 rounded-md shadow">
        <p className="text-gray-900 dark:text-gray-200">
          <strong>Step {stepIndex + 1} / {steps.length}:</strong> {message}
        </p>
        <p className="text-gray-500 dark:text-gray-400 mt-2">
          <strong>left:</strong> {left}, <strong>right:</strong> {right}
          {mid !== null && <> , <strong>mid:</strong> {mid}</>}
        </p>
      </div>
    </div>
  );
};

export default BinarySearchAnimation;
